/* globals $: true, window: true, document: true */

$(function() {
  $('.report').hide();
  $('.report-problem-close').hide();
  $('.report-problem-save').hide();

  $(".report input:checkbox").on('click', function() {
    // in the handler, 'this' refers to the box clicked on
    var $box = $(this);
    if ($box.is(":checked")) {
      // the name of the box is retrieved using the .attr() method
      // as it is assumed and expected to be immutable
      var group = "input:checkbox[name='" + $box.attr("name") + "']";
      // the checked state of the group/box on the other hand will change
      // and the current value is retrieved using .prop() method
      $(group).prop("checked", false);
      $box.prop("checked", true);
    } else {
      $box.prop("checked", false);
    }
  });

	$('.code-fix-show').on('click', function(e) {
		e.preventDefault();

		var container = $($(this).closest('.code-line-container'));
		$('.code-lines.without-fixes', container).hide();
		$('.code-lines.with-fixes', container).show();
		$('.code-fix-hide', container).show();
		$(this).hide();
	});

	$('.code-fix-hide').on('click', function(e) {
		e.preventDefault();

		var container = $(this).closest('.code-line-container');
		$('.code-lines.without-fixes', container).show();
		$('.code-lines.with-fixes', container).hide();
		$('.code-fix-show', container).show();
		$(this).hide();
	});

  $('.report-problem').on('click', function(e) {
    e.preventDefault();

    var container = $($(this).closest('.code-line-container'));
    if (container.length === 0) {
      container = $($(this).closest('.tabs-content'));
    }
    container.addClass('report-form-open');
    $('.report-problem-close', container).show();
    $('.report-problem-save', container).hide();
    $('.report', container).show();
    $(this).hide();
  });

  $('.report-problem-close').on('click', function(e) {
    e.preventDefault();

    var container = $($(this).closest('.code-line-container'));
    if (container.length === 0) {
      container = $($(this).closest('.tabs-content'));
    }
    container.removeClass('report-form-open');
    $('.report', container).hide();
    $(this).hide();
    $('.report-problem-save', container).hide();
    $('.report-problem', container).show();
  });

  $('.report-comment').on('input', function() {
    var container = $($(this).closest('.code-line-container'));
    if (container.length === 0) {
      container = $($(this).closest('.tabs-content'));
    }
    var close = $('.report-problem-close', container);
    var save = $('.report-problem-save', container);

    if (this.value.length > 0 || $(':checkbox:checked', container).length > 0) {
      close.hide();
      save.show();
    } else {
      close.show();
      save.hide();
    }
  });

  $(':checkbox').on('click', function() {
    var container = $($(this).closest('.code-line-container'));
    if (container.length === 0) {
      container = $($(this).closest('.tabs-content'));
    }
    var close = $('.report-problem-close', container);
    var save = $('.report-problem-save', container);
    if (this.checked) {
      if (this.value != $('.report-reason', container).attr('report-reason')) {
        close.hide();
        save.show();
      } else {
        close.show();
        save.hide();
      }
    } else {
      close.hide();
      save.show();
    }
  });

  $('.report-problem-save').on('click', function(e) {
    e.preventDefault();
    
    var container = $($(this).closest('.code-line-container'));
    if (container.length === 0) {
      container = $($(this).closest('.tabs-content'));
    }
    var reason = $(':checked', container).val();
    var id = container.attr('data-id');
    var url = '/ignores/' + container.attr('data-type') + '/' + container.attr('data-package');
    if (reason && reason.length > 0) {
      executePost(url, {
        problemId : id,
        comment : $('.report-comment', container).val(),
        reason : reason
      }).fail(function(error) {
        alert(error.response.message);
      }).done(function(response) {
        container.removeClass('report-form-open');
        $('.report', container).hide();
        $('.report-problem-close', container).hide();
        $('.report-problem-save', container).hide();
        $('.report-problem', container).text('Reported');
        $('.report-problem', container).show();
        updateCounterAndIgnoredItems();
      });
    } else {
      executeDelete(url, {
        problemId : id
      }).fail(function(error) {
        alert(error);
      }).done(function(response) {
        container.removeClass('report-form-open');
        $('.report', container).hide();
        $('.report-problem-close', container).hide();
        $('.report-problem-save', container).hide();
        $('.report-problem', container).text('Report');
        $('.report-problem', container).show();
        $('.report-comment', container).text('');
        updateCounterAndIgnoredItems();
      });
    }
  });
  
  $('#new-all-selector').on('change', function(e) {
    var element = $('#new-all-selector');
    var id = element.data('id');
    var filter = element.val();
    var url = '/result/' + id;
    if (filter === 'new') {
      url += '/' + filter;
    }
    window.location.href = url;
  });
});

function handleIgnored(item) {
  if (item.isIgnored) {
    $('.' + item.id).addClass('ignored');
  } else {
    $('.' + item.id).removeClass('ignored');
  }
}

function updateCounterAndIgnoredItems() {
  executeGet('/app/analyze/result/' + $('#headerSection').attr('data-id')).done(function(response) {
    $('#critical-count').text(response.problemCount.critical);
    $('#severe-count').text(response.problemCount.severe);
    $('#warning-count').text(response.problemCount.warning);

    response.problems.forEach(function(problem) {
      handleIgnored(problem);
      if (problem.classes) {
        problem.classes.forEach(function(class) {
          handleIgnored(class);
          if (class.lines) {
            class.lines.forEach(function(line) {
              handleIgnored(line);
            }, this);
          }
        }, this);
      }
    }, this);
  });
}

var remember = 0;

function animateValue(id, start, end, duration) {
  var range = end - start;
  var current = start;
  var increment = end > start ? 1 : -1;
  var stepTime = Math.abs(Math.floor(duration / range));
  var obj = document.getElementById(id);
  var timer = setInterval(function() {
    current += increment;
    obj.setAttribute('offset', current + "%");
    if (current == end) {
      clearInterval(timer);
    }
  }, stepTime);
}

function makePayment(apiServer, id, token, coupon) {
  $.post(apiServer + '/purchase/result/' + id, {
    token  : token.id,
    coupon : coupon
  }, function(data) {
    if(data.success) {
      window.location.reload();
    } else {
      window.location = '/problem';
    }
  }).fail(function() {
    window.location = '/problem';
  });
}

function paymentComplete() {
  $('.unpaid').removeClass('unpaid');
  $('.expander .tooltip').remove();
  $('section.sell .wrap').html('<h3><span><i>Thanks!</i></span> You\'re on the way to getting secure.</h3><h4>If you have any questions, feel free to email us at <strong><a href="mailto: hello@codifiedsecurity.com">hello@codifiedsecurity.com</a></strong>.</h4>');
}

function loadingLoop(id, apiServer, oldStatus) {
  $.get(apiServer + '/app/analyze/result/' + id, function(data) {
    var newPercent = 0,
      currentPercent = parseInt($('.progress-bar').data('percent'), 10);
    if (data.status === 'uploaded' && oldStatus === 'new' || !oldStatus) {
      newPercent = Math.floor(Math.random() * 10) + 20;
    } else if (data.status === 'completed') {
      newPercent = 100;
    } else {
      newPercent = Math.min(currentPercent + Math.floor(Math.random() * 10 + 3), 90);
    }
    oldStatus = data.status;
    newPercent = Math.max(currentPercent, newPercent);
    $('.progress-bar').data('percent', newPercent);
    if (remember != newPercent) {
      animateValue('F1gst1', remember, newPercent, 500);
      $('.progress-nr').text(newPercent + '%');
      document.title = newPercent + '% Loaded • ' + document.title;
      remember = newPercent;
    }
    if (data.status === 'completed' || data.status === 'failed') {
      window.location = '/result/' + id;
      return;
    }
    setTimeout(function() {
      loadingLoop(id, apiServer, oldStatus);
    }, 2400);
  });
}

function computePrice(inEu, price) {
  if(inEu) {
    return price * 1.2;
  }

  return price;
}
